import React from 'react'
import ParticlesAuth from '../../AuthenticationInner/ParticlesAuth';
import { Col, Container, Row } from 'reactstrap';
import error from '../../../assets/images/out-of-permission.svg';
import { Link } from 'react-router-dom';

function OutOfPermission() {
  document.title = 'Out of Permission | Adcropper';
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className='auth-page-content mt-lg-5'>
          <Container>
            <Row>
              <Col lg={12}>
                <div className='text-center pt-4'>
                  <div className="">
                    <img src={error} alt="" className="error-basic-img move-animation" />
                  </div>
                  <div className="mt-n4">
                    <h3 className="display-4 fw-medium">OUT OF PERMISSION</h3>
                    <p className="text-muted mb-4">You do not have permission to access this page. Please check your credentials or contact your company admin.</p>
                    <Link to="/" className="btn btn-success"><i className="mdi mdi-home me-1"></i>Back to home</Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  )
}

export default OutOfPermission
